import { Controller } from 'stimulus'
import { useBusItem } from './mixins/useBusItem.js'
import { useDispatch } from 'stimulus-use'
import Rails from '@rails/ujs'
import I18n from '@app/javascript/i18n/index.js.erb'
import { flashError } from '@app/javascript/classes/flashMessages'

export default class extends Controller {
  static targets = [
    'exportFilename',
    'exportFormatXLSX',
    'exportFormModal',
    'exportProcessingModal',
    'exportButton'
  ]

  static values = {
    busItemId: String,
    exportOrigin: String,
    searchAttributes: String,
    entityIds: Array,
    total: Number,
    savePath: String,
    saveHttpVerb: String
  }

  connect() {
    useBusItem(this)
    useDispatch(this)
    this.SEND_SEGMENT_DATA_ORIGIN_WHITELIST = ['actionSearch']
  }

  triggerBulkExport(event) {
    event.preventDefault()

    const filenameParams = { filename: this.exportFilenameTarget.value }
    const ext = this.exportFormatXLSXTarget.checked ? 'xlsx' : 'csv'
    const serializedParams = this.searchAttributesValue
    const additionalParams = {
      title: filenameParams.filename,
      file_format: ext,
      origin: this.exportOriginValue,
      'search_attributes[actions_ids]': []
    }

    this.entityIdsValue.forEach(referenceId => {
      additionalParams['search_attributes[actions_ids]'].push(referenceId)
    })

    const data = [serializedParams, $.param(additionalParams)].join('&')
    this.saveExport(data) // Segment tracking handled within this function due to callback.
  }

  saveExport(data) {
    this.exportButtonDisable()

    Rails.ajax({
      type: this.saveHttpVerbValue || 'POST',
      url: this.savePathValue || '/exports',
      dataType: 'json',
      data: data,
      success: (response) => {
        this.exportFormModalTarget.classList.add('hidden')
        this.exportProcessingModalTarget.classList.remove('hidden')
        this.exportButtonEnable()

        if (this.shouldSendSegmentData()) { this.sendSegmentData($.deparam(data), response.id) }
      },
      error: () => {
        this.exportFormModalTarget.classList.add('hidden')
        this.exportProcessingModalTarget.classList.add('hidden')
        this.exportButtonEnable()

        flashError(I18n.t('common.something_went_wrong_try_again'))
      }
    })
  }

  shouldSendSegmentData() {
    return this.SEND_SEGMENT_DATA_ORIGIN_WHITELIST.includes(this.exportOriginValue)
  }

  sendSegmentData(exportData, exportId) {
    const exportAll = this.entityIdsValue.length === 0
    const itemCount = exportAll ? this.totalValue : this.entityIdsValue.length
    const actionExportResults = exportAll ? null : this.entityIdsValue

    this.dispatch(
      'exportCreated',
      {
        actionExportResults,
        exportAll,
        exportData,
        exportId,
        itemCount
      }
    )
  }

  exportButtonDisable() {
    this.exportButtonTarget.disabled = true
    this.exportButtonTarget.innerHTML = this.exportButtonTarget.dataset.disabledWith
  }

  exportButtonEnable() {
    this.exportButtonTarget.disabled = false
    this.exportButtonTarget.innerHTML = this.exportButtonTarget.dataset.enabledWith
  }
}
